export const STATUS_LABELS = {
  new:                      'New',
  escalated:                'Escalated',
  dept_action_pending:      'Dept. Action Pending',
  dept_confirmed:           'Dept. Confirmed',
  in_progress:              'Under Process',  // D4: stale alias of under_process — same label
  under_process:            'Under Process',
  pending_customer_contact: 'Pending Customer Contact',
  pending_finance:          'Pending Finance',
  resolved:                 'Resolved',
  closed:                   'Closed',
  reopened:                 'Reopened',
};

export const STATUS_COLORS = {
  new:         'bg-blue-100 text-blue-800',
  in_progress: 'bg-yellow-100 text-yellow-800',
  resolved:    'bg-green-100 text-green-800',
  closed:      'bg-gray-100 text-gray-700',
};

export const PRIORITY_COLORS = {
  critical: 'bg-red-100 text-red-800 border border-red-200',
  high: 'bg-orange-100 text-orange-800 border border-orange-200',
  medium: 'bg-yellow-100 text-yellow-800 border border-yellow-200',
  low: 'bg-green-100 text-green-800 border border-green-200',
};

export const PRIORITY_LABELS = {
  critical: '🔴 Critical',
  high: '🟠 High',
  medium: '🟡 Medium',
  low: '🟢 Low',
};

export const CHANNEL_SOURCES = [
  'Phone', 'WhatsApp', 'Email', 'App', 'Website', 'Instagram',
  'Walk-in', 'Survey', 'Other'
];

export const ROLE_LABELS = {
  super_admin:       'Super Admin',
  entity_manager:    'Entity Manager',
  agent:             'Agent',
  dept_user:         'Department User',
  dept_manager: 'Department Manager',
};

export const STATUS_FLOW = [
  'new',
  'escalated',
  'dept_action_pending',
  'in_progress',
  'pending_customer_contact',
  'resolved',
  'closed',
  'reopened',
];

// Status Progress bar steps. Every status maps to exactly one step:
// new→1, escalated→2, dept states→3, under_process→4, pending_finance→5,
// resolved→6, reopened→7, closed→8. (in_progress is a stale alias for
// under_process per D4; pending_customer_contact rides with step 4.)
export const STATUS_STEPS = [
  { key: 'new',             label: 'New',             statuses: ['new', 'open'] },
  { key: 'escalated',       label: 'Escalated',       statuses: ['escalated'] },
  { key: 'dept',            label: 'Dept.',           statuses: ['dept_action_pending', 'dept_confirmed'] },
  { key: 'under_process',   label: 'Under Process',   statuses: ['under_process', 'in_progress', 'acknowledged'] },
  { key: 'pending_finance', label: 'Pending Finance', statuses: ['pending_finance', 'pending_third_party'] },
  // pending_customer_contact rides with Resolved: the close flow treats the two
  // identically (both show the Step-B "contact customer then close" panel).
  { key: 'resolved',        label: 'Resolved',        statuses: ['resolved', 'pending_customer_contact'] },
  { key: 'reopened',        label: 'Reopened',        statuses: ['reopened'] },
  { key: 'closed',          label: 'Closed',          statuses: ['closed'] },
];

export const TRANSLATIONS = {
  en: {
    submitComplaint: 'Submit a Complaint',
    name: 'Full Name',
    mobile: 'Mobile Number',
    email: 'Email Address',
    complaintType: 'Complaint Type',
    description: 'Description',
    submit: 'Submit',
    thankYou: 'Thank you for your feedback!',
    ticketCreated: 'Your complaint has been received.',
    selectType: 'Select complaint type',
    required: 'This field is required',
    orderRef: 'Order Reference',
    mealDate: 'Meal Date',
    photo: 'Attach Photo',
  },
  ar: {
    submitComplaint: 'تقديم شكوى',
    name: 'الاسم الكامل',
    mobile: 'رقم الجوال',
    email: 'البريد الإلكتروني',
    complaintType: 'نوع الشكوى',
    description: 'الوصف',
    submit: 'إرسال',
    thankYou: 'شكراً على ملاحظاتك!',
    ticketCreated: 'تم استلام شكواك.',
    selectType: 'اختر نوع الشكوى',
    required: 'هذا الحقل مطلوب',
    orderRef: 'رقم الطلب',
    mealDate: 'تاريخ الوجبة',
    photo: 'إرفاق صورة',
  }
};
